export default [
    {name: "closing_date", value: "closing_date", type: "date"},
    {name: "balance_sheet", childs: [
	{name: "total_assets", value: "financial_data.balance_sheet.total_assets", childs: [
	    {name: "fixed_assets", value: "financial_data.balance_sheet.fixed_assets", childs: [
		{name: "intangible_fixed_assets", value: "financial_data.balance_sheet.intangible_fixed_assets"},
		{name: "tangible_fixed_assets", value: "financial_data.balance_sheet.tangible_fixed_assets"},
		{name: "other_fixed_assets", value: "financial_data.balance_sheet.other_fixed_assets"}
	    ]},
	    {name: "current_assets", value: "financial_data.balance_sheet.current_assets", childs: [
		{name: "stocks", value: "financial_data.balance_sheet.stocks"},
		{name: "debtors", value: "financial_data.balance_sheet.debtors"},
		{name: "other_current_assets", value: "financial_data.balance_sheet.other_current_assets", childs: [
		    {name: "cash_cash_equivalent", value: "financial_data.balance_sheet.cash_cash_equivalent"}]}
	    ]}
	]},
	{name: "shareholders_funds", value: "financial_data.balance_sheet.shareholders_funds", childs: [
	    {name: "capital", value: "financial_data.balance_sheet.capital"},
	    {name: "other_shareholders_funds", value: "financial_data.balance_sheet.other_shareholders_funds"}
	]},
	
	{name: "total_liabilities", value: "financial_data.balance_sheet.total_liabilities", childs: [
	    {name: "long_term_debt", value: "financial_data.balance_sheet.long_term_debt"},
	    {name: "non_current_liabilities", value: "financial_data.balance_sheet.non_current_liabilities", childs: [
		{name: "other_non_current_liabilities", value: "financial_data.balance_sheet.other_non_current_liabilities"}

	    ]},

	    {name: "current_liabilities", value: "financial_data.balance_sheet.current_liabilities", childs: [
		{name: "loans", value: "financial_data.balance_sheet.loans"},
		{name: "creditors", value: "financial_data.balance_sheet.creditors"},
		{name: "other_current_liabilities", value: "financial_data.balance_sheet.other_current_liabilities"}
	    ]}
	]},
	{name: "total_shareholders_funds_liabilities", value: "financial_data.balance_sheet.total_shareholders_funds_liabilities"},
	{name: "net_financial_position", value: "net_financial_position", type: "date", skip_xls: true, childs: [
	    {name: "short_term_debt", value: "financial_data.balance_sheet.short_term_debt", hide_xls: true},
	    {name: "long_term_debt", value: "financial_data.balance_sheet.long_term_debt", hide_xls: true},
	    {name: "cash_cash_equivalent", value: "financial_data.balance_sheet.cash_cash_equivalent", hide_xls: true},
	    {name: "net_debt", value: "financial_data.balance_sheet.net_debt", hide_xls: true}
	    
	]},
	{name: "closing_date", value: "closing_date", type: "date", skip_xls: true, hide_xls: true, childs: [
	    {name: "working_capital", value: "financial_data.balance_sheet.working_capital"},
	    {name: "net_current_assets", value: "financial_data.balance_sheet.net_current_assets"}
	]}

    ]},
    {name: "income_statement", childs: [
	{name: "sales", value: "financial_data.income_statement.sales", childs: [
	    {name: "other_revenues", value: "financial_data.income_statement.other_revenues"}
	]},
	{name: "operating_revenue_or_turnover", value: "financial_data.income_statement.operating_revenue_or_turnover"},
	{name: "total_costs", value: "financial_data.income_statement.total_costs", childs: [
	    {name: "service_costs", value: "financial_data.income_statement.service_costs"},
	    {name: "material_costs", value: "financial_data.income_statement.material_costs"},
	    {name: "costs_of_employees", value: "financial_data.income_statement.costs_of_employees"}
	]},
	{name: "costs_of_good_sold", value: "financial_data.income_statement.costs_of_good_sold", is_uk:true},
	{name: "other_operating_expenses", value: "financial_data.income_statement.other_operating_expenses", is_uk:true},
	{name: "gross_profit", value: "financial_data.income_statement.gross_profit", is_uk:true},
	{name: "ebitda", value: "financial_data.income_statement.ebitda"},
	{name: "depreciation", value: "financial_data.income_statement.depreciation"},
	{name: "ebit", value: "financial_data.income_statement.ebit"},
	{name: "financial_pl", value: "financial_data.income_statement.financial_pl", childs: [
	    {name: "financial_revenue", value: "financial_data.income_statement.financial_revenue"},
	    {name: "financial_expenses", value: "financial_data.income_statement.financial_expenses", childs: [
		{name: "interest_paid", value: "financial_data.income_statement.interest_paid"}
	    ]}
	]},
	{name: "pl_before_tax", value: "financial_data.income_statement.pl_before_tax"},
	{name: "extraordinary_and_other_pl", value: "financial_data.income_statement.extraordinary_and_other_pl", childs: [
	    {name: "extraordinary_and_other_revenue", value: "financial_data.income_statement.extraordinary_and_other_revenue"},
	    {name: "extraordinary_and_other_expenses", value: "financial_data.income_statement.extraordinary_and_other_expenses"}
	]},
	{name: "pl_before_tax_extraordinary_and_other_pl", value: "financial_data.income_statement.pl_before_tax_extraordinary_and_other_pl"},
	{name: "taxation", value: "financial_data.income_statement.taxation"},
	{name: "pl_for_period", value: "financial_data.income_statement.pl_for_period"},
	{name: "cash_flow", value: "financial_data.income_statement.cash_flow"},
	{name: "added_value", value: "financial_data.income_statement.added_value"},
	{name: "number_of_employees", value: "financial_data.income_statement.number_of_employees"}
    ]}
    
]
